export const FEATURE_NAME = 'organizations';

export const ORGANIZATION_KINDS = {
  AUGENMOBIL: 1,
  NURSING_HOME: 2,
  OPTICIAN: 3,
  CLINIC: 4,
};

export const CURRENT = 'current';

export const KIND = 'kind';

export const ADDRESS = 'address';
export const CITY = 'city';
export const ZIP_CODE = 'zipCode';
export const CANTON = 'canton';
export const COUNTRY = 'country';
export const PHONE = 'phone';
export const EMAIL = 'email';
export const ORG_URL = 'url';
export const TITLE = 'title';
export const GENDER = 'gender';
export const SPECIALTY = 'specialty';
export const DESCRIPTION = 'description';
export const CHANNEL = 'channel';
export const SHARE = 'share';
export const CONSENT = 'consent';
export const PATIENT_NAME = 'patientName';
export const NURSING_HOME_KIND = 'nursingHomeKind';
export const SEND_REPORTS_TO = 'sendReportsTo';
export const ISSUES_PRESCRIPTIONS = 'issuesPrescriptions';

export const CONTACTS = 'contacts';
export const DOCTOR = 'gp';
export const MAIN = 'main';
export const OPHTHALMOLOGY = 'ophthalmology';

export const FIRST_NAME = 'firstname';
export const LAST_NAME = 'lastname';
export const NO_PATIENT_REPORTS = 'noPatientReports';
export const NO_GP_REPORTS = 'noGPReports';
export const NO_OPTICIAN_REPORTS = 'noOpticianReports';
export const NO_REFERRALS = 'noReferrals';
export const IS_REFERRAL_PARTNER = 'isReferralPartner';
export const REFERRAL_CANTONS = 'referralCantons';

export const FROM = 'from';
export const TO = 'to';

export const FILTERS = 'filters';

export const CONTACT_FORM_NAME = {
  [MAIN]: 'Kontaktperson',
  [DOCTOR]: 'Heimarzt/-ärztin',
};
export const REPORTS_TYPES = Object.keys(CONTACT_FORM_NAME).map((id) => ({ id, label: CONTACT_FORM_NAME[id] }));

export const CONTACT_FORM_DESCRIPTION = {
  [MAIN]:
    'Die Kontaktperson des Pflegezentrums (meist Administration oder Sekretariat) erhält automatisch die Befunde sowie Erinnerungen an ungelesene Berichte. So wird sichergestellt, dass alle Berichte zentral entgegengenommen und korrekt abgelegt werden.',
  [DOCTOR]:
    'Im Bericht wird die Heimärztin oder der Heimarzt unter «Kopie an» erwähnt. Systemnachrichten und Erinnerungen zu neuen Befunden gehen jedoch ausschliesslich an die Kontaktperson des Pflegezentrums.',
};

export const CONTACT_TITLE = {
  [ORGANIZATION_KINDS.CLINIC]: 'Praxis/Klinik',
  [ORGANIZATION_KINDS.NURSING_HOME]: 'Pflegezentrum',
  [ORGANIZATION_KINDS.OPTICIAN]: 'Optiker',
};

export const CONTACT_KINDS = {
  [ORGANIZATION_KINDS.CLINIC]: [MAIN],
  [ORGANIZATION_KINDS.NURSING_HOME]: [MAIN, DOCTOR],
  [ORGANIZATION_KINDS.OPTICIAN]: [MAIN],
};

export const ORGANIZATION_STATUS = [
  { id: 1, label: 'Aktiv' },
  { id: 0, label: 'Inaktiv' },
];

export const SERVICES = 'services';
export const YAG_LASER = 'yagLaser';
export const BIOMETRY = 'biometry';
export const SERVICE_ITEMS = [
  {
    id: YAG_LASER,
    label: 'YAG-Laser',
  },
  {
    id: BIOMETRY,
    label: 'Biometrie',
  },
  {
    id: 'wheelchairAccessible',
    label: 'Praxis rollstuhlgängig',
  },
  {
    id: 'smallLiftOnly',
    label: 'nur kleiner Lift',
  },
];

export const CONSENTS = [
  { id: 'default', label: 'Standard' },
  { id: 'no_gp', label: 'Ohne Hausarzt' },
];

export const GENDER_TYPES = { NEUTRAL: 'neutral', FEMALE: 'female', MALE: 'male' };
export const GENDERS = [
  { value: GENDER_TYPES.NEUTRAL, label: 'Das' },
  { value: GENDER_TYPES.FEMALE, label: 'Die' },
  { value: GENDER_TYPES.MALE, label: 'Der' },
];

const PATIENT_NAME_TYPES = { DEFAULT: 'default', GUEST: 'guest' };
export const PATIENT_NAMES = [
  { id: PATIENT_NAME_TYPES.DEFAULT, label: 'Bewohner' },
  { id: PATIENT_NAME_TYPES.GUEST, label: 'Gäste' },
];

export const NURSING_HOME_KINDS = [
  { id: 1, label: 'Alters- und Pflegeheim', gender: GENDER_TYPES.NEUTRAL, patientName: PATIENT_NAME_TYPES.DEFAULT },
  { id: 2, label: 'Alterswohngemeinschaft', gender: GENDER_TYPES.FEMALE, patientName: PATIENT_NAME_TYPES.DEFAULT },
  { id: 3, label: 'Alterszentrum', gender: GENDER_TYPES.NEUTRAL, patientName: PATIENT_NAME_TYPES.DEFAULT },
  { id: 4, label: 'Betagtenheim', gender: GENDER_TYPES.NEUTRAL, patientName: PATIENT_NAME_TYPES.DEFAULT },
  { id: 5, label: 'Gesundheitszentrum für das Alter', gender: GENDER_TYPES.NEUTRAL, patientName: PATIENT_NAME_TYPES.DEFAULT },
  { id: 6, label: 'Pflegezentrum', gender: GENDER_TYPES.NEUTRAL, patientName: PATIENT_NAME_TYPES.DEFAULT },
  { id: 7, label: 'Seniorenheim', gender: GENDER_TYPES.NEUTRAL, patientName: PATIENT_NAME_TYPES.DEFAULT },
  { id: 8, label: 'Stiftung', gender: GENDER_TYPES.FEMALE, patientName: PATIENT_NAME_TYPES.DEFAULT },
  { id: 9, label: 'Tertianum', gender: GENDER_TYPES.NEUTRAL, patientName: PATIENT_NAME_TYPES.GUEST },
];
